import MeasureRepresentation from "./measure-representation.ts";
import MeasureShapesType from "@/models/enums/measure-shapes.ts";

class MeasureShape {
    measureShapeId: string;
    
    name: MeasureShapesType;
    
    representations: MeasureRepresentation[] = [];
    
    constructor(measureShapeId: string, name: MeasureShapesType) {
        this.measureShapeId = measureShapeId;
        this.name = name;
    }
}

export default MeasureShape;